import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { StackedBarChartProps } from '../types/chartProps';
import { applyBarChartOptions } from '../utils/barChartUtils';
import { applyRedrawForBaseChart } from '../utils/baseChartUtils';
import { mergeWithDefaults } from '../utils/chartDefaults';
import { getStackingValue } from '../utils';

export const StackedBarChart = React.memo(
  React.forwardRef<HighchartsReact.RefObject, StackedBarChartProps>((props, ref) => {
    const redraw = { skip: false };
    const options: Highcharts.Options = applyBarChartOptions(
      mergeWithDefaults({
        chart: {
          type: 'column',
          events: {
            redraw: applyRedrawForBaseChart(redraw)
          }
        },
        plotOptions: {
          column: {
            stacking: getStackingValue(props)
          },
          series: {
            borderWidth: 0
          }
        }
      }),
      { ...props, kind: 'bar' }
    );

    return <HighchartsReact highcharts={Highcharts} options={options} ref={ref} />;
  })
);
